"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineStatusBadge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const MachineStatus_1 = require("../../../modules/advertising/enums/MachineStatus");
const advertising_module_scss_1 = __importDefault(require("../advertising.module.scss"));
const MachineStatusBadge = ({ status, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const isOnline = status === MachineStatus_1.MachineStatus.Online;
    return ((0, jsx_runtime_1.jsxs)("span", { className: `${advertising_module_scss_1.default.statusPill} ${isOnline ? '' : advertising_module_scss_1.default.offline}`, children: [(0, jsx_runtime_1.jsx)("span", { className: advertising_module_scss_1.default.statusDot, "aria-hidden": "true" }), t(isOnline
                ? 'advertising.machines.statusOnline'
                : 'advertising.machines.statusOffline')] }));
};
exports.MachineStatusBadge = MachineStatusBadge;
